import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { PessoaContato } from '../pessoa-contato';
import { PessoaContatoTipo } from '../tipo';
import { PessoaContatoUpdateSituacao } from '../situacao';

@Injectable({
    providedIn: 'root'
})
export class PessoaContatoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pessoa`;
    }

    /** Carrega o contato através do seu ID */
    load(idContato: number): Observable<PessoaContato> {
        return this.customHttp.get<PessoaContato>(`${this.pathApi}/0/contato/${idContato}`);
    }

    /** Procura o contato da pessoa e tipo informados */
    findContato(idPessoa: number, tipo: PessoaContatoTipo): Observable<PessoaContato> {
        // Params
        const params = new HttpParams()
                            .append('tipo', tipo ? tipo.id.toString() : 'null');

        return this.customHttp.get<PessoaContato>(`${this.pathApi}/${idPessoa}/contato`, {params});
    }

    /** Pesquisa os contatos da pessoa informada */
    searchContatos(idPessoa: number): Observable<PessoaContato[]> {
        return this.customHttp.get<PessoaContato[]>(`${this.pathApi}/${idPessoa}/contatos`);
    }

    /** Insere um novo contato */
    insert(idPessoa: number, entity: PessoaContato): Observable<PessoaContato> {
        return this.customHttp.post<PessoaContato>(`${this.pathApi}/${idPessoa}/contato`, entity);
    }

    /** Atualiza um contato */
    update(entity: PessoaContato): Observable<PessoaContato> {
        return this.customHttp.put<PessoaContato>(`${this.pathApi}/0/contato`, entity);
    }

    /** Atualiza a situação de um contato */
    updateSituacao(updateSituacao: PessoaContatoUpdateSituacao): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/0/contato/situacao`, updateSituacao);
    }
}
